import { Route, NavigationGuardNext } from "vue-router";
import { getModule } from "vuex-module-decorators";
import LessonPlanListState from "@/modules/lesson-plan-list";
import UnitState from "@/modules/unit";
import { VCSLevelUnitResponseModel } from "@/services/text-guardian/unit-list";

export const ConversationMasterBuilderResolver = async function (to: Route, from: Route, next: NavigationGuardNext) {
	const lessonPlanListModule = getModule(LessonPlanListState);
	const unitModule = getModule(UnitState);

	if (!unitModule.units || !unitModule.units.length) {
		if (lessonPlanListModule.allUnits && lessonPlanListModule.allUnits.length) {
			unitModule.setUnits(
				lessonPlanListModule.allUnits.map(
					(item) =>
						({
							id: item.id,
							componentCount: 0,
							disable: item.disabled,
							displayName: item.displayName,
							curriculumType: item.curriculumType,
							unit: item.unit,
							sequence: item.sequence
						} as VCSLevelUnitResponseModel)
				)
			);
		} else {
			await unitModule.fetchUnits({ details: false });
		}
	}

	next();
};
